<template>
  <FormPanel
      headline="Create Primary Menu Link Child"
      :errors="errors"
      @submit="submit"
  />
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import FormPanel from '../../../../../../../components/Administration/PrimaryMenuLinks/Panels/Form'

export default {
  components: {FormPanel},

  props: {
    portal: {
      required: true
    }
  },

  data() {
    return {
      errors: {}
    }
  },

  methods: {
    submit(data) {
      http.post('/api/v2/primary-menu-link-children', {...data, primary_menu_link_id: this.$route.params.primaryMenuLinkId})
          .then(() => {
            notify.success('The primary menu link child was saved')

            this.$router.push('/portals/' + this.portal.id + '/content/primary-menu-links/'+this.$route.params.primaryMenuLinkId + '/edit')
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    }
  }
}
</script>
